import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Badge from '@mui/material/Badge'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { Link, useLocation  } from 'react-router-dom'

import logo from '../../assets/commerce.png'
import './navbar.css'

const Navbar = ({ totalItems }) => {

const location = useLocation()

  return (

    <>
    
        <AppBar position="fixed" className="appBar" color="inherit">

            <Toolbar>

                <Link to="/">

                    <Typography variant="h6" className="title">

                        <img src={logo} alt="Commerce.js" height="25" className="logo" />
                        
                        Commerce.js

                    </Typography>

                </Link>

                <div className="grow" />

                {location.pathname === '/' && (

                    <div>

                    <Link to="/cart">

                        <IconButton>

                            <Badge badgeContent={totalItems} color="secondary">

                                <ShoppingCartIcon />

                            </Badge>

                        </IconButton>

                    </Link>

                    </div>

                )}                

            </Toolbar>

        </AppBar>
    
    </>

  )

}

export default Navbar